module.exports = __webpack_public_path__ + "img/logo.a5a0f995.svg";